/**
 *
 * @module entry
 * @desc {SDK.Services.Media} entry point.
 *
 */

import AdEngine from './adEngine/entry';
import BifThumbnailSet from './bifThumbnailSet';
import DrmType from './drmType';
import MediaClientConfiguration from './mediaClientConfiguration';
import MediaClient from './mediaClient';
import MediaClientEndpoint from './mediaClientEndpoint';
import MediaPayload from './mediaPayload';
import MediaPlayhead from './mediaPlayhead';
import MediaPlayheadStatus from './mediaPlayheadStatus';
import MediaThumbnailLink from './mediaThumbnailLink';
import MediaThumbnailLinks from './mediaThumbnailLinks';
import Presentation from './presentation';
import SpriteThumbnailSet from './spriteThumbnailSet';
import StreamSampleConfiguration from './streamSampleConfiguration';
import ThumbnailPresentationType from './thumbnailPresentationType';
import ThumbnailSet from './thumbnailSet';

/**
 *
 * @typedef SDK.Services.Media
 * @type {Object}
 *
 * @property {AdEngine} AdEngine
 * @property {BifThumbnailSet} BifThumbnailSet
 * @property {DrmType} DrmType
 * @property {MediaClientConfiguration} MediaClientConfiguration
 * @property {MediaClient} MediaClient
 * @property {MediaClientEndpoint} MediaClientEndpoint
 * @property {MediaPayload} MediaPayload
 * @property {MediaPlayhead} MediaPlayhead
 * @property {MediaPlayheadStatus} MediaPlayheadStatus
 * @property {MediaThumbnailLink} MediaThumbnailLink
 * @property {MediaThumbnailLinks} MediaThumbnailLinks
 * @property {Presentation} Presentation
 * @property {StreamSampleConfiguration} StreamSampleConfiguration
 * @property {SpriteThumbnailSet} SpriteThumbnailSet
 * @property {ThumbnailPresentationType} ThumbnailPresentationType
 * @property {ThumbnailSet} ThumbnailSet
 *
 */

/**
 *
 * @type {SDK.Services.Media}
 *
 */
export default {

    AdEngine,
    BifThumbnailSet,
    DrmType,
    MediaClientConfiguration,
    MediaClient,
    MediaClientEndpoint,
    MediaPayload,
    MediaPlayhead,
    MediaPlayheadStatus,
    MediaThumbnailLink,
    MediaThumbnailLinks,
    Presentation,
    StreamSampleConfiguration,
    SpriteThumbnailSet,
    ThumbnailPresentationType,
    ThumbnailSet

};



// WEBPACK FOOTER //
// ./src/services/media/entry.js